<div class="manage-plan-content">

  <div class="page-header">
    <wfm-page-title title="{{'plan.page.title' | translate}}"></wfm-page-title>
    <div *ngIf="false">
      <breeze-button buttonText="CXone" [isSecondary]="true" (clicked)="showCreateCxonePlanDlg()">
      </breeze-button>
    </div>
    <div>
      <breeze-button *ngIf="hasEspModifyPermission" buttonText="{{'plan.label.newplan' | translate}}" id="btn-new-plan"
        [isPrimary]="true" (clicked)="showIexOrCxonePlanDlg()">
      </breeze-button>
    </div>
    <!-- Per the ESP-11194, the create v1 plan dialog code is commented for future use.
    <ng-template #elseBlock>
      <breeze-button *ngIf="hasEspModifyPermission" buttonText="{{'plan.label.newplan' | translate}}" id="btn-new-plan"
        [isPrimary]="true" (clicked)="showCreatePlanDlg()">
      </breeze-button>
    </ng-template> -->
  </div>
  <div class="search-box">
    <input-text #searchTextBox inputId="search-text-box" [isSearchField]="true" [isDisabled] = "false"
                [required]="false"
                placeHolderText="{{'plan.search.ph' | translate}}"
                ariaLabel="{{'plan.search.label' | translate}}"
                [announcement]="searchAnnouncement"
                (onTextChangeWithTimeout)="filterRows($event)">
    </input-text>

    <ng-template #multiPlanDelete>
      <div role="dialog"
           aria-labelledby="multi-plan-delete-title"
           tabindex="-1"
           (keydown.tab)="onPlanDeleteDialogTab($event)">
        <div class="message-delete">
          <p id="multi-plan-delete-title">{{'plan.delete.multiple' | translate }} </p>
        </div>
        <div class="button-response">
          <breeze-button [isSecondary]="true" [showTooltip] = "false" buttonText="{{'btn.cancel.label' | translate }}" (clicked)="planDeletePopover.close()"></breeze-button>
          <breeze-button [isPrimary]="true" [showTooltip] = "false" buttonText="{{'btn.confirm.label' | translate }}" (clicked)="deleteSelectedPlans()"></breeze-button>
        </div>
      </div>
    </ng-template>
    <div class="search-actions" *ngIf="hasEspModifyPermission">
      <breeze-button #planDeletePopover="ngbPopover" buttonText="{{'plan.label.delete' | translate}}" [isSecondary]="true" [isDisabled]="!hasSelectedPlan" id="btn-delete"
        placement="left" [ngbPopover]="multiPlanDelete" (shown)="focusDeleteDialog()" (hidden)="returnFocusToPlanDeleteBtn()" tooltipPosition="left">
      </breeze-button>
    </div>
  </div>
  <div class="plan-list table-list">
    <!-- a11y (ESP-18522): row-level open action announced once on grid entry
         via aria-describedby; each cell still announces only its own content. -->
    <p id="planGridActivationHelp" class="screenreader-only">{{ 'plan.grid.activation.help' | translate }}</p>
    <!-- a11y (ESP-21718) / ESP-21806: columns are not draggable at all
         ([suppressMovableColumns]), so there is no column-reorder DOM/Tab-order
         desync to fix and no need for the grid-wide `ensureDomOrder` option
         (whose forced body-row DOM re-splicing on scroll recycle caused stale
         hover / duplicate tooltips during fast scrolling). -->
    <ag-grid-angular full-width-table
                    [noRowsOverlayComponent]="noPlanOverlayComponent"
                    [noRowsOverlayComponentParams]="noPlanOverlayComponentParams"
                    [tableRef]="planList"
                    class="ag-theme-balham no-column-borders"
                    [ngClass]="{'plans-loaded': !isLoading()}"
                    (cellClicked)="performCellClick($event)"
                    (cellKeyDown)="onCellKeyDown($event)"
                    (cellFocused)="onCellFocused($event)"
                    [suppressMovableColumns]="true"
                    [rowSelection]="rowSelection"
                    [selectionColumnDef]="selectionColumnDef"
                    [suppressAutoSize]="true"
                    [columnDefs]="columnDefs"

                    [context]="context"
                    [headerHeight]="40"
                    [icons]="icons"
                    [localeText]="gridAriaLocaleText"
                    [defaultColDef]="defaultColDef"
                    #planList
                    [components]="frameworkComponents"
                    (gridReady)="onGridReady($event)"
                    (firstDataRendered)="applyCheckboxAriaLabels()"
                    (rowDataUpdated)="applyCheckboxAriaLabels()"
                    (selectionChanged)="applyCheckboxAriaLabels()"
                    (modelUpdated)="applyCheckboxAriaLabels()"
                    [rowClassRules]="rowClassRules"
                    [debug]="false"
                    [rowHeight]="36"
                    [animateRows] ="false"
                    [rowModelType]="rowModelType"
                    [infiniteInitialRowCount]="infiniteInitialRowCount"
                    [rowBuffer]="rowBuffer"
                    [loadingOverlayComponent]="loadingOverlayComponent"
                    [loadingOverlayComponentParams]="loadingOverlayParams"
                    [enableBrowserTooltips]="true">
    </ag-grid-angular>
  </div>
</div>

<p-toast position="bottom-right">

</p-toast>

<div class="dialog-container"></div>
